'use client';
import * as React from 'react';

import { ActionsFeedback } from '../../../ui/shared';
import { useUpdatePasswordStore } from '../../stores/update-password-store';

const UpdatePasswordFeedback = () => {
  const { actionFeedback, setActionFeedback, setError, setIsLoading } = useUpdatePasswordStore();

  return (
    <ActionsFeedback
      {...actionFeedback}
      open={!!actionFeedback}
      onClose={() => {
        setError(null);
        setIsLoading(false);
        setActionFeedback(null);
      }}
      message={actionFeedback?.message}
    />
  );
};

export default UpdatePasswordFeedback;
